module.exports = __webpack_public_path__ + "files/becd7c30960f2de369603af14ab5682c.png";